import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    withStyles,
} from '@material-ui/core';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});

const NetworkZoneConfirmationDialog = props => {
    let { classes, confirmationDialogOpen, handleConfirmTrue, handleConfirmFalse, translations, confirming, subnet } = props;

    return (
        <Dialog
            open={confirmationDialogOpen}
            onClose={handleConfirmFalse}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{translations['confirm_network_zone_override'] || 'Confirm Network Zone Override'}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {`${translations['sure_want_delete_all_other_network_zones_with_subnet'] || `Are you sure you want to delete all other Network Zones with subnet`} ${subnet}?`}
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleConfirmFalse} variant="contained" className={classes.buttonSafe} disabled={confirming}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={handleConfirmTrue} variant="contained" className={classes.buttonDanger} disabled={confirming}>
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, { withTheme: true })(NetworkZoneConfirmationDialog);